import { Box, BoxProps } from "@mui/material";
import { stringToColor } from "../../services";

export const Avatar = (props: { string: string; size?: "small" | "medium" | "large" }) => {
  const getSize = () => {
    if (props.size === "small") {
      return "20px";
    }

    if (props.size === "medium" || props.size === undefined) {
      return "40px";
    }

    if (props.size === "large") {
      return "55px";
    }

    return "40px";
  };

  const _size = getSize();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: stringToColor(props.string),
        color: "white",
        height: _size,
        width: _size,
        fontSize: `${parseInt(_size) / 2}px`,
        borderRadius: "50%",
      }}
      children={`${props.string.split(" ")[0][0]}${props.string.split(" ")[1][0]}`}
    />
  );
};
